import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const updateIndexApi = createApi({
    reducerPath: "updateIndexApi",
    tagTypes: ["updateIndex"],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: (build) => ({
        updateIndex: build.mutation({
            query: (data) => ({
                url: api.updateIndex.updateIndex(),
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["updateIndex"],
        }),
    }),
});

export const {
    useUpdateIndexMutation,
} = updateIndexApi;
